<template>
  <div id="HomePage">
    <!-- 右侧悬浮窗 -->
    <div class="floating-box hidden-xs hidden-sm hidden-md">
      <div class="floating-item mb" @click="yjdhGO">
        <div class="floating-item-img"><img src="@/assets/img/drawing/h-dh.png" alt=""></div>
        <div class="floating-item-text">一键导航</div>
      </div>
      <div class="floating-item mb" @click="yjydGO">
        <div class="floating-item-img"><img src="@/assets/img/drawing/h-dd.png" alt=""></div>
        <div class="floating-item-text">一键预定</div>
      </div>
      <div class="floating-item mb" @click="zxdhGO">
        <div class="floating-item-img"><img src="@/assets/img/drawing/h-phone.png" alt=""></div>
        <div class="floating-item-text">咨询电话</div>
        <div class="dialog-box-css">
          <div class="dialog-top-cont">联系电话：{{lxwmData.mobile}}</div>
          <div class="floating-top-right">
            <div class="floating-top-right-item">
              <img v-lazy="wxObj.value" alt="">
              <div>{{$t('wechat')}}</div>
            </div>
            <div class="floating-top-right-item">
              <img v-lazy="wbObj.value" alt="">
              <div>{{$t('micro_blog')}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="floating-item" @click="lyhdGO">
        <div class="floating-item-img"><img src="@/assets/img/drawing/h-ly.png" alt=""></div>
        <div class="floating-item-text">留言互动</div>
      </div>
    </div>
    <!-- 轮播图 -->
    <div id="swiper" class="container-fuild">
      <div class="swiper-container banner-swiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(item,index) in swiperList" :key="index">
            <img class="swiper-lazy" :data-src="item.banner" alt="轮播图">
            <div class="swiper-lazy-preloader"></div>
            <!--<div class="swiper-slide-title">
                <h1>{{item.title}}</h1>
                <p>{{item.content}}</p>
            </div>-->
          </div>
        </div>
        <!-- 如果需要分页器 -->
        <div class="swiper-pagination"></div>

        <!-- 如果需要导航按钮 -->
        <div class="swiper-button-prev"></div>
        <div class="swiper-button-next"></div>
      </div>
    </div>

    <div class="conts-box">
      <div class="item-box1 hidden-xs hidden-sm hidden-md">
        <!-- 景区动态 -->
        <div id="bigData" class="container-fuild">
          <div class="title-cont">
            <i></i>
            <div class="text-cont">{{$t('Scenic_spot_dynamics')}}</div>
          </div>
          <div class="bigData-container" v-for="(item,i) in jqdtDataList" :key="i" style="margin-top: 45px" >
            <div class="jqdt-img-box" style="width:300px;height:200px">
              <img v-lazy="item.cover" alt="景区动态" style="width: 100%;height: 100%">
            </div>
            <div class="bigData-text-box">
              <div class="bigData-title">{{item.title}}</div>
              <p>{{item.brief}}</p>
            </div>
            <div class="ckgd-btn-css" @click="goDetail(item.id)">{{$t('view_more')}}</div>
          </div>
          <div class="ckgd-box-css">
            <div class="ckgd-btn" @click="goNewDynamic">
              <span>{{$t('view_more')}}</span>
              <i class="el-icon-d-arrow-right"></i>
            </div>
          </div>
        </div>
        <!-- 营业时间 -->
        <div class="yysj-box">
          <div class="timeWeatherBox">
            <div class="real-time-box">
              <div class="real-time-text">{{dateH}}</div>
              <div class="real-time-colon">:</div>
              <div class="real-time-text">{{dateM}}</div>
            </div>
            <div class="weather-box">
              <div class="year-box">{{dateYear}}({{dateWeek}})</div>
              <timeWeather></timeWeather>
            </div>
          </div>
          <div class="yysj-time-box">
            <div class="yysj-itle">
              <div class="box-icon"></div>
              <div class="text-cont">{{$t('businessHours')}}</div>
            </div>
            <div class="yysj-time-cont" style="border-bottom: 2px solid #00B197;border-radius: 0 0 15px 15px">
              <div class="yysj-time-item" v-for="(item,index) in jqListDataArr" :key="'sj'+index">
                <div class="labels">
                  <span class="labels-name">{{item.name}}</span>
                  <span class="labels-tags">({{item.business_date}})</span>
                </div>
                <div class="times">{{item.start_business_hours}}-{{item.end_business_hours}}</div>
              </div>
              <div class="tag-text" >*{{$t('yysj_hint')}}</div>
            </div>
            <div style="margin-top: 40px;">
              <div class="yysj-itle" style="margin-top: -10px">
              <div class="box-icon"></div>
              <div class="text-cont">{{$t('scenicSpotAddress')}}</div>
            </div>
            <div class="yysj-time-cont" style="border-bottom: 2px solid #00B197;border-radius: 0 0 15px 15px">
              <div v-for="(item,index) in jqListDataArr" :key="'dz'+index">
                <div class="labels-dz">
                  <div class="icons">
                    <i class="el-icon-location"></i>
                  </div>
                  <div class="dz">{{item.name}}</div>
                </div>
                <div class="dz-text" style="border-bottom: 1px solid #999;">{{item.address}}</div>
              </div>
            </div>
            </div>
          </div>
        </div>
      </div>
      <div class="item-box1 visible-xs visible-sm visible-md">
        <div class="title-cont">
          <i></i>
          <div class="text-cont">{{$t('Scenic_spot_dynamics')}}</div>
        </div>
        <!-- 营业时间 -->
        <div class="yysj-box">
          <div class="yysj-time-box">
            <div class="yysj-itle">
              <div class="box-icon"></div>
              <div class="text-cont">{{$t('businessHours')}}</div>
            </div>
            <div class="yysj-time-cont" style="border-bottom: 2px solid #00B197;border-radius: 0 0 15px 15px">
              <div class="yysj-time-item" v-for="(item,index) in jqListDataArr" :key="'sj'+index">
                <div class="labels">
                  <span class="labels-name">{{item.name}}</span>
                  <span class="labels-tags">({{item.business_date}})</span>
                </div>
                <div class="times">{{item.start_business_hours}}-{{item.end_business_hours}}</div>
              </div>
              <div class="tag-text" >*{{$t('yysj_hint')}}</div>
            </div>
            <div style="margin-top: 40px;">
              <div class="yysj-itle" style="margin-top: -10px">
                <div class="box-icon"></div>
                <div class="text-cont">{{$t('scenicSpotAddress')}}</div>
              </div>
              <div class="yysj-time-cont" style="border-bottom: 2px solid #00B197;border-radius: 0 0 15px 15px">
                <div v-for="(item,index) in jqListDataArr" :key="'dz'+index">
                  <div class="labels-dz">
                    <div class="icons">
                      <i class="el-icon-location"></i>
                    </div>
                    <div class="dz">{{item.name}}</div>
                  </div>
                  <div class="dz-text" style="border-bottom: 1px solid #999;">{{item.address}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 景区动态 -->
        <div class="container-fuild">
          <div class="bigData-container" v-for="(item,i) in jqdtDataList" :key="i" style="margin-top: 10rem" >
            <div class="jqdt-img-box">
              <img v-lazy="item.cover" alt="景区动态" style="width: 100%;height: 100%">
            </div>
            <div class="bigData-text-box">
              <div class="bigData-title">{{item.title}}</div>
            </div>
            <div class="ckgd-btn-css" @click="goDetail(item.id)">{{$t('view_more')}}</div>
          </div>
          <div class="ckgd-box-css">
            <div class="ckgd-btn" @click="goNewDynamic">
              <span>{{$t('view_more')}}</span>
              <i class="el-icon-d-arrow-right"></i>
            </div>
          </div>
        </div>
      </div>

      <div class="item-box2">
        <!-- 景区简介 -->
        <div class="title-cont">
          <i></i>
          <div class="text-cont">{{$t('yqsgljj')}}</div>
        </div>
        <div class="jj-box">
          <div class="zhjj-box" style=" text-indent: 40px;">{{$t('jqjj_text')}}</div>
          <div class="jj-item" v-for="(item,index) in jqListDataArr" :key="'jj'+index">
            <div class="jj-item-tit">{{item.name}}</div>
            <div class="jj-item-cont" style=" text-indent: 40px;" v-html="item.detail"></div>
            <div class="hidden-xs hidden-sm hidden-md" style="position: relative">
              <div class="swiper-container" :class="'customer-swiper'+index" style="width:100%">
                <div class="swiper-wrapper">
                  <div class="swiper-slide customer-item-box" v-for="(itemSwiper,index) in item.customerList" :key="'s'+index">
                    <div class="customer-cont">
                      <div class="customer-cont-title"><div></div>{{itemSwiper.name}}</div>
                      <img class="customer-cont-img" v-lazy="itemSwiper.cover" alt="logo">
                      <div class="customer-cont-bottom" @click="jdDetailGo(itemSwiper.id)">
                        <span>{{$t('Click_for_details')}}</span>
                        <i class="el-icon-arrow-right"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="swiper-button-prev" :class="'swiper-button-prev'+index" style="position: absolute;left: 0;top: 50%"></div>
              <div class="swiper-button-next" :class="'swiper-button-next'+index" style="position: absolute;right: 0;top: 50%"></div>
            </div>

            <div class="visible-xs visible-sm visible-md" style="position: relative">
              <div class="swiper-container" :class="'p-customer-swiper'+index" style="width:100%">
                <div class="swiper-wrapper">
                  <div class="swiper-slide customer-item-box" v-for="(itemSwiper,index) in item.customerList" :key="'s'+index">
                    <div class="customer-cont" style="width: 100%;" >
                      <div class="customer-cont-title"><div></div>{{itemSwiper.name}}</div>
                      <img class="customer-cont-img" v-lazy="itemSwiper.cover" alt="logo">
                      <div class="customer-cont-bottom" @click="jdDetailGo(itemSwiper.id)">
                        <span>{{$t('Click_for_details')}}</span>
                        <i class="el-icon-arrow-right"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="item-box3">
        <!-- 玩转景区 -->
        <div class="title-cont">
          <i></i>
          <div class="text-cont">{{$t('playspot')}}</div>
        </div>
        <div class="">
          <div class="hidden-xs hidden-sm hidden-md" style="position: relative;margin-top:60px">
            <div class="swiper-container wzjq-swiper pc-wzjq-swiper" style="width: 100%" @click="ywglGO">
              <div class="swiper-wrapper">
                <div class="swiper-slide customer-block" v-for="(item,index) in wzjqSwiperList" :key="index">
                  <div class="wzjq-list-item">
                    <div class="wzjq-list-name">{{item.name}}</div>
                    <img class="wzjq-list-img" v-lazy="item.cover" alt="logo">
                  </div>
                </div>
              </div>
            </div>
            <!-- 如果需要分页器 -->
            <div class="swiper-pagination swiper-wzjq-pagination"></div>
          </div>
          <div class="visible-xs visible-sm visible-md" style="padding-top: 20rem">
            <div class="swiper-container wzjq-swiper phone-wzjq-swiper" style="width: 100%" @click="ywglGO">
              <div class="swiper-wrapper">
                <div class="swiper-slide customer-block" v-for="(item,index) in wzjqSwiperList" :key="index">
                  <div class="wzjq-list-item">
                    <div class="wzjq-list-name">{{item.name}}</div>
                    <img class="wzjq-list-img" v-lazy="item.cover" alt="logo">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="item-box4">
      <!-- 诗意玉泉 -->
      <div class="title-cont">
        <i></i>
        <div class="text-cont">{{$t('syyq_text')}}</div>
      </div>
      <div class="syyq-box">
        <div class="syyq-item" style="background-color: #00B197">
          <img class="syyg-img" v-lazy="scgfObj.cover" alt="">
          <div class="text-box" style="background-color: #00B197" @click="yqsGo(3)">
            <p class="syyq-item-title">{{$t('scgf_text')}}</p>
            <p class="ckgd-btn">{{$t('view_more')}}</p>
          </div>
        </div>
        <div class="syyq-cont">
          <div class="syyq-item syyq-center-item" style="background-color: #FF9255;width: 45%;">
            <img class="syyg-img" v-lazy="videoObj.cover" alt="">
            <div class="text-box" style="background-color: #FF9255" @click="yqsGo(2)">
              <p class="syyq-item-title">{{$t('video')}}</p>
              <p class="ckgd-btn">{{$t('view_more')}}</p>
            </div>
          </div>
          <div class="syyq-item syyq-center-item" style="background-color: #44FAA9;width: 45%;">
            <img class="syyg-img" v-lazy="audioObj.cover" alt="">
            <div class="text-box" style="background-color: #44FAA9" @click="yqsGo(1)">
              <p class="syyq-item-title">{{$t('audio')}}</p>
              <p class="ckgd-btn">{{$t('view_more')}}</p>
            </div>
          </div>
        </div>
        <div class="syyq-item" style="background-color: #a81940">
          <img class="syyg-img" v-lazy="mtjObj.cover" alt="">
          <div class="text-box" style="background-color: #a81940" @click="yqsGo(0)">
            <p class="syyq-item-title">{{$t('mtj_text')}}</p>
            <p class="ckgd-btn">{{$t('view_more')}}</p>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import Swiper from "swiper";
import { WOW } from 'wowjs';
import timeWeather from '@/components/timeWeather';
import {companyProfile} from "@/api/api";
import {getBanner,getActivityList,getBusinessHours,getScenicSpot,ywglGetType,poeticJadeSpring,commonQrcode} from "@/api/index"
export default {
  name: "HomePage",
  components: {
    timeWeather
  },
  data() {
    return {
      swiperList: [],//轮播图
      lxwmData:{},
      wbObj:{},
      wxObj:{},

      jqdtDataList:[],//景区动态
      dateH: null,
      dateM: null,
      dateS: null,
      dateYear: null,
      dateWeek: null,
      weekday: ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"],
      timer:null,
      jqListDataArr:[],
      wzjqSwiperList: [],
      scgfObj:{},//诗词歌赋
      mtjObj:{},//美图集
      videoObj:{},//视频
      audioObj:{},//音频

      swiperHeight:0,
    };
  },
  mounted() {
    let widthSwiper = document.documentElement.clientWidth;
    this.swiperHeight = widthSwiper - 120

    this.getCompanyAttract();
    this.getCommonQrcodeData();
    this.getBannerData();
    this.getActivityListData();
    this.yysjGetData();
    this.wzjqGetList();
    this.syyqGetList();




    /* 玩转景区 */
    new Swiper(".pc-wzjq-swiper", {
      observer: true, //修改swiper自己或子元素时，自动初始化swiper
      observeParents:false,//修改swiper的父元素时，自动初始化swiper
      // 如果需要前进后退按钮
      /*navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      },*/
      //自动播放
      /*autoplay: {
        delay: 3000,
        stopOnLastSlide: false,
        disableOnInteraction: false
      },*/
      // 如果需要分页器
      pagination: {
        el: ".swiper-wzjq-pagination",
        clickable: true
      },
      grabCursor: true,
      loop: true,
      initialSlide:4,
      effect : 'coverflow',
      slidesPerView: 4,
      spaceBetween:10,
      centeredSlides: true,
      centeredSlidesBounds: true,
      coverflowEffect: {
        rotate: 0,
        stretch: 10,
        depth: 80,
        modifier: 2,
        slideShadows : true
      },

    });
    new Swiper(".phone-wzjq-swiper", {
      observer: true, //修改swiper自己或子元素时，自动初始化swiper
      observeParents:false,//修改swiper的父元素时，自动初始化swiper
      grabCursor: true,
      loop: true,
      initialSlide:2,
      effect : 'coverflow',
      slidesPerView: 2,
      spaceBetween:0,
      centeredSlides: true,
      centeredSlidesBounds: true,
      coverflowEffect: {
        rotate: 0,
        stretch:-6,
        depth: 160,
        modifier: 2,
        slideShadows : false
      },

    });

    /* wowjs动画 */
    var wow = new WOW({
      boxClass: 'wow',
      animateClass: 'animated',
      offset: 0,
      mobile: true,
      live: true
    })
    wow.init();
    /* 实时时间 */
    this.timer =setInterval(() => {
      const date=this.$dayjs(new Date())
      this.dateH = date.format('HH');
      this.dateM = date.format('mm');
      this.dateS = date.format('ss');
      this.dateYear = date.format('YYYY-MM-DD');
      this.dateWeek = date.format(this.weekday[date.day()]);
    }, 1000)
  },
  beforeDestroy(){
    if(this.timer){
      clearInterval(this.timer)
    }
  },
  methods:{
    yjdhGO(){
      sessionStorage.setItem('navIndex',5)
      this.$router.push({
        path:'/oneClickNavigation',
      })
    },
    yjydGO(){
      sessionStorage.setItem('navIndex',5)
      this.$router.push({
        path:'/oneClickReserve',
      })
    },
    zxdhGO(){

    },
    lyhdGO(){
      sessionStorage.setItem('navIndex',5)
      this.$router.push({
        path:'/MessageBoard',
      })
    },
    getCompanyAttract(){
      let lanage = window.localStorage.getItem("locale");
      companyProfile({language:lanage}).then(res => {
        this.lxwmData = res.data;
      });
    },
    getCommonQrcodeData(){
      commonQrcode().then(res => {
        res.data.map((item)=>{
          if(item.name == 'micro_blog'){
            this.wbObj = item;
          }
          if(item.name == 'official_account'){
            this.wxObj = item;
          }
        })
      });
    },
    //轮播图
    getBannerData(){
      let lanage = window.localStorage.getItem("locale");
      getBanner({type:1,language:lanage}).then(res => {
        this.swiperList = res.data;
          this.$nextTick(()=>{
            /* banner-swiper */
            new Swiper(".banner-swiper", {
              loop: true, // 循环模式选项
              effect: 'fade',
              //自动播放
              autoplay: {
                delay: 3000,
                stopOnLastSlide: false,
                disableOnInteraction: false
              },
              // 如果需要分页器
              pagination: {
                el: ".swiper-pagination",
                clickable: true
              },
              // 如果需要前进后退按钮
              navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev"
              },
              // 延迟加载
              lazy: {
                loadPrevNext: true
              },
              observer: true, //修改swiper自己或子元素时，自动初始化swiper
              observeParents: true //修改swiper的父元素时，自动初始化swiper
            });
          })

      });
    },
    //景区动态
    getActivityListData(){
      let lanage = window.localStorage.getItem("locale");
      let param = {
        type:1,
        language:lanage,
        page:1,
        limit:3,
      }
      getActivityList(param).then(res => {
        this.jqdtDataList = res.data;
      });
    },
    goDetail(id){
      sessionStorage.setItem('navIndex',3)
      this.$router.push({
        path:'/jqhdDetail/'+id+'/'+1,
      })

    },
    //查看更多
    goNewDynamic(){
      sessionStorage.setItem('navIndex',3)
      this.$router.push({
        path:'/recentnews',
      })
    },
    //景区列表，营业时间
    yysjGetData(){
      let lanage = window.localStorage.getItem("locale");
      getBusinessHours({language:lanage}).then(res => {
        this.jqListDataArr = res.data;
        this.jqListDataArr.map((item,index)=>{
          this.getScenicSpotList(item.id,index);
          if(item.name == '关陵'){
            sessionStorage.setItem('glid',item.id);
          }
          if(item.name == '玉泉山'){
            sessionStorage.setItem('yqsid',item.id);
          }
        })
        console.log(this.jqListDataArr);

      });
    },
    getScenicSpotList(id,i){
      let lanage = window.localStorage.getItem("locale");
      getScenicSpot({business_id:id,language:lanage}).then(res => {
        this.jqListDataArr[i].customerList = res.data;

        this.$nextTick(()=>{
          /* customer-swiper */
          new Swiper(".customer-swiper"+i, {
            observer: true, //修改swiper自己或子元素时，自动初始化swiper
            observeParents:false,//修改swiper的父元素时，自动初始化swiper
            // 如果需要前进后退按钮
            navigation: {
              nextEl: ".swiper-button-next"+i,
              prevEl: ".swiper-button-prev"+i
            },
            //自动播放
            /*autoplay: {
              delay: 3000,
              stopOnLastSlide: false,
              disableOnInteraction: false
            },*/
            grabCursor: true,
            loop: true,
            initialSlide:2,
            effect : 'coverflow',
            slidesPerView: 3,
            spaceBetween:20,
            centeredSlides: true,
            centeredSlidesBounds: true,
            coverflowEffect: {
              rotate: 0,
              stretch:-60,
              depth: 160,
              modifier: 2,
              slideShadows : false
            },

          });
          /* phone-customer-swiper */
          new Swiper(".p-customer-swiper"+i, {
            observer: true, //修改swiper自己或子元素时，自动初始化swiper
            observeParents:false,//修改swiper的父元素时，自动初始化swiper
            //自动播放
            /*autoplay: {
              delay: 3000,
              stopOnLastSlide: false,
              disableOnInteraction: false
            },*/
            grabCursor: true,
            loop: true,
            initialSlide:2,
            effect : 'coverflow',
            slidesPerView: 2,
            spaceBetween:-30,
            centeredSlides: true,
            centeredSlidesBounds: true,
            coverflowEffect: {
              rotate: 0,
              stretch:22,
              depth: 160,
              modifier: 2,
              slideShadows : false
            },

          });
        })
      });
    },
    jdDetailGo(id){
      this.$router.push({
        path:'/scenicSpotDetail/'+id,
      })
    },
    //玩转景区
    wzjqGetList(){
      let lanage = window.localStorage.getItem("locale");
      ywglGetType({language:lanage}).then(res => {
        this.wzjqSwiperList =  res.data;
      });
    },
    ywglGO(){
      sessionStorage.setItem('navIndex',4)
      this.$router.push({
        path:'/playguide',
      })
    },
    //诗意玉泉
    syyqGetList(){
      let lanage = window.localStorage.getItem("locale");
      poeticJadeSpring({language:lanage}).then(res => {
        res.data.map((item,index)=>{
          if(item.identification == "POETRY"){
            this.scgfObj = item;
          }
          if(item.identification == "VIDEO"){
            this.videoObj = item;
          }
          if(item.identification == "AUDIO"){
            this.audioObj = item;
          }
          if(item.identification == "IMG"){
            this.mtjObj = item;
          }
        })
        console.log(this.scgfObj);
      });
    },
    yqsGo(num){
      sessionStorage.setItem('yqsTabIndex',num)
      sessionStorage.setItem('navIndex',1)
      this.$router.push({
        path:'/service',
      })
    }

  },
};
</script>

<style scoped src="../assets/css/homepage.css"/>




// WEBPACK FOOTER //
// src/view/HomePage.vue